import { v4 as uuidv4 } from "uuid";

class UUIDService {
    create() {
        return uuidv4();
    }
}
const uuidServiceInstance = new UUIDService();
export default uuidServiceInstance;
